import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./orderSubMaintenanceTypeId"

export default {
	updateField,
	SET_ORDERSUBMAINTENANCES(state, payload) {
		state.orderSubMaintences = payload

	},
	SET_ORDERSUBMAINTENANCE(state, payload) {
		state.orderSubMaintences = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_provider[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_provider) {
			state.validation_provider[key] = null
		}
	},
}
